.infoBox {
  display: flex;
  padding: 1em;
  margin-bottom: 1em;
  border: 0.1em solid var(--blue);
}

.infoIcon {
  font-size: 3em;
  color: var(--blue) !important;

  &::after {
    vertical-align: top;
  }
}

.infoContent {
  width: 100%;
  padding: 0.3em 1.5em;
  word-wrap: break-word;
}

.infoTitle {
  text-transform: uppercase;
}
